import { LeadCardAvatar } from "./avatar";
import { LeadInfo } from "./lead-info";
import { clsxMerge } from "shared/lib/helpers";
import { DialerConnectionLabel } from "@/components/modules/calling/cards/lead-card/v2/lead-avatar/connection-label";

export const LeadCard = () => {
  return (
    <div className="flex h-full items-center justify-start">
      <div className={clsxMerge("relative flex justify-center")}>
        <LeadCardAvatar
          className={clsxMerge("relative justify-start")}
          avatarClassName="relative w-[90px] z-[1]"
          ripplesClassName="z-[0] relative top-[45px] scale-[1]"
        />

        <DialerConnectionLabel
          className={clsxMerge("absolute top-[calc(50%+18px)] z-10")}
        />
      </div>

      <LeadInfo />
    </div>
  );
};
